import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

   private key128 = CryptoJS.enc.Utf8.parse('1234567890123456'); // 16-byte key
  private iv128 = CryptoJS.enc.Utf8.parse('1234567890123456'); // 16-byte IV

  private key = CryptoJS.enc.Utf8.parse('12345678901234567890123456789012'); // 32-byte key
  private iv = CryptoJS.enc.Utf8.parse('1234567890123456'); // 16-byte IV


  // AES Encryption
  encrypt128(data: string): string {
    const encrypted = CryptoJS.AES.encrypt(data, this.key128, {
      iv: this.iv128,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  }

  encrypt256(data: string): string {
    const encrypted = CryptoJS.AES.encrypt(data, this.key, {
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString(); // Returns Base64 string
  }


}
